import { isSuperAdmin, useCurrentUser } from 'hooks/useCurrentUser';
import { RoleCode, User } from 'types';

const isTenantAdmin = (user: User): boolean =>
  Boolean(user.roles?.some((role) => role.code === RoleCode.TENANT_ADMIN));

/**
 * Who may use the legacy tenancy switcher: BC staff, or the MP tenant_admin
 * role. The switcher never renders on an AMS session, so the role read is
 * legacy-only by construction. Delete together with LegacyTenancySwitcher.
 */
export function useCanSwitchTenancy(): { loading: boolean, canSwitchTenancy: boolean } {
  const { user } = useCurrentUser();

  return {
    loading: !user,
    canSwitchTenancy: user ? (isSuperAdmin(user) || isTenantAdmin(user)) : false,
  }
}
